
// get-set cookie
function setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
}

function getCookie(c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
}
  
document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("click", function(event) {
        var viewButtonGrid = event.target.closest(".view-button-grid");
        var viewButtonList = event.target.closest(".view-button-list");

        if (viewButtonGrid) {
            var datacookie = viewButtonGrid.getAttribute("data-view-val");
            setCookie("datacookie", datacookie, 1);
            viewButtonGrid.classList.add("active"); 
            document.getElementById("product-grid").classList.add("product-grid-view");
            const nodeList = document.querySelectorAll(".view-button-list");
            for (let i = 0; i < nodeList.length; i++) {
              nodeList[i].classList.remove("active");
            }
            document.getElementById("product-grid").classList.remove("product-list-view");
        }
        if (viewButtonList) {
            var datacookie = viewButtonList.getAttribute("data-view-val");
            setCookie("datacookie", datacookie, 1);
            viewButtonList.classList.add("active");
            const nodeList = document.querySelectorAll(".view-button-grid");
            for (let i = 0; i < nodeList.length; i++) {
              nodeList[i].classList.remove("active");
            }
          document.getElementById("product-grid").classList.add("product-list-view");            
          document.getElementById("product-grid").classList.remove("product-grid-view");
          
        }
    });

    var x = getCookie('datacookie');  
    if (x === "product-list-view") {
      
      const nodeList = document.querySelectorAll(".view-button-list");
      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].classList.add("active");
      }
      document.getElementById('product-grid').classList.add("product-list-view");         
    }else{
      const nodeList = document.querySelectorAll(".view-button-grid");
      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].classList.add("active");
      }
      document.getElementById('product-grid').classList.add("product-grid-view");
    }  
});

// Default Function Overriding start
function updatedRenderFilters(html, event) {
  // default function start
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  const facetDetailsElements = parsedHTML.querySelectorAll(
    '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
  );
  const matchesIndex = (element) => {
    const jsFilter = event ? event.target.closest('.js-filter') : undefined;
    return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
  };
  const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
  const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

  facetsToRender.forEach((element) => {
    document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
  });

  FacetFiltersForm.renderActiveFacets(parsedHTML);
  FacetFiltersForm.renderAdditionalElements(parsedHTML);

  if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  // default function end
  
  // custom custom js grid/list view selected after sort by start    
  function getCookie(c_name) {
      var i, x, y, ARRcookies = document.cookie.split(";");
      for (i = 0; i < ARRcookies.length; i++) {
          x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
          y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
          x = x.replace(/^\s+|\s+$/g, "");
          if (x == c_name) {
              return unescape(y);
          }
      }
  }
  setTimeout(function() {
    var x = getCookie('datacookie');  
    if (x === "product-list-view") {
      const nodeList = document.querySelectorAll(".view-button-grid");
      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].classList.remove("active");
      }
      document.getElementById('product-grid').classList.add("product-list-view");         
    }else{
      const nodeList = document.querySelectorAll(".product-list-view"); 
      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].classList.remove("active");
      }
      document.getElementById('product-grid').classList.add("product-grid-view");
    }              
  }, 10 );          
  // custom js grid/list view selected after sort by end
}
window.addEventListener('DOMContentLoaded', function () {
   FacetFiltersForm.renderFilters = updatedRenderFilters;
});

// Default Function Overriding end